import request from '@/utils/request'

// 产品分类
export const getCategoryList = (productId) => {
  return request({
    url: `/trace/product/category/${productId}`
  })
}
